module.exports = __webpack_public_path__ + "static/metal-white-af23ea112ac0177c8fd931631f0145d7.png";